import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const hotelApi = createApi({
  reducerPath: "hotelApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getHotelList: builder.query({
      query: () => `/api/staff/getHotels/0`,
    }),
    getHotelDetails: builder.query({
      query: (id) => `/api/staff/getHotels/${id}`,
    }),
    createHotel: builder.mutation({
      query: (newHotelData) => ({
        url: `/api/staff/hotel/addEdit`,
        method: "POST",
        body: newHotelData,
      }),
    }),
    editHotel: builder.mutation({
      query: (editHotelData) => ({
        url: `/api/staff/hotel/addEdit`,
        method: "POST",
        body: editHotelData,
      }),
    }),
    getHotelSearch: builder.query({
      query: (searchkey) => `/api/staff/searchHotel/${searchkey}`,
    }),
    hotelPlaceList: builder.query({
      query: () => `/api/admin/getPlace`,
    }),
  }),
});

export const { useGetHotelListQuery, useGetHotelDetailsQuery, useCreateHotelMutation, useEditHotelMutation, useLazyGetHotelSearchQuery, useHotelPlaceListQuery } = hotelApi;
